module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("K.S. King is an award-winning Canadian journalist, reporting and editing publications on crime and courts, education, politics, oil and gas, agriculture, indigenous relations and the environment. Growing up in a rural Newfoundland out-port community, Savage Cove, (pop. 133), King was surrounded by storytellers, fishermen, hunters, tanners, gardeners, and crafters. She is married to an Anglican pastor; has two LGBTQ2S+ sons and routinely volunteers in the LGBTQ2S+ community, Anglican ministries, and facilitating Christian women’s retreats.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Today, King shares her journalism and communication knowledge, as well as her love of reading, to students and staff as middle-school librarian in Calgary.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0